"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "30", height: "30", viewBox: "0 0 30 30", className: "Icon green-tick", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("circle", { fill: "#379802", cx: "15", cy: "15", r: "15" }),
            _react2.default.createElement("path", { d: "M13.06 21.182l10.061-10.06L21 9l-7.94 7.924L9.622 13.5 7.5 15.621z", fill: "#FFF" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/green-tick.js
// module id = 1805
// module chunks = 0